import {EDITOR_MODE} from '@/Constant';

enum GET_KU_STATUS_TYPE {
    GET_KU_MODE = 'GET_KU_MODE',
}

const KU_STATUS_TYPE_MAP = {
    [GET_KU_STATUS_TYPE.GET_KU_MODE]: 'KU_MODE',
};

const KU_NOTIFY_STATUS_TYPE = 'KU_STATUS_NOTIFY';

export type IMode = EDITOR_MODE | null | 'presentation';

let mode: IMode = null;

const handlePostMessage = (data: any) => {
    const message = {
        type: KU_NOTIFY_STATUS_TYPE,
        data,
    };
    window.postMessage(message, '*');
};

export const sendModeChangeNotify = () => {
    handlePostMessage({
        type: KU_STATUS_TYPE_MAP[GET_KU_STATUS_TYPE.GET_KU_MODE],
        status: {
            mode,
        },
    });
};

export const updateKuStatusMode = (newMode: IMode) => {
    mode = newMode;
    sendModeChangeNotify();
};

const handleKuStatus = (event: MessageEvent) => {
    try {
        if (!(event && event.data && event.data.type)) {
            return {};
        }
        const type: GET_KU_STATUS_TYPE = event.data.type;

        switch (type) {
            case GET_KU_STATUS_TYPE.GET_KU_MODE: {
                handlePostMessage({
                    type: KU_STATUS_TYPE_MAP[type],
                    status: {
                        mode,
                    },
                });
                break;
            }
            default:
                break;
        }
    } catch (err) {
        console.error(err);
    }
};

export const initKuNotifyStatus = () => {
    try {
        sendModeChangeNotify();
        window.addEventListener('message', handleKuStatus);
        return () => {
            window.removeEventListener('message', handleKuStatus);
        };
    } catch (err) {
        return () => {};
    }
};
